import { render, staticRenderFns } from "./colEstado.vue?vue&type=template&id=6bd64ff4&"
import script from "./colEstado.vue?vue&type=script&lang=js&"
export * from "./colEstado.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports